<template>
	<div class="hairInfo">
		<div style="margin-left: 20px">
			<h3 class="el-tabs-pane-nav">商品详情</h3>
			<el-form label-position="left" label-width="150px">
				<div class="el-tabs-pane-upload-item2">
					<el-form-item label="商品封面">
						<el-upload class="upload-demo" action="https://admin.ciaojian.com/file/file_upload"
							:file-list="form2.image_list" :on-success=add :on-remove=remove list-type="picture">
							<el-button size="small" type="primary">点击上传</el-button>
						</el-upload>
					</el-form-item>
					<el-form-item label="状态">
						<span v-model="status">
							{{this.status | statusFormat}}
						</span>
					</el-form-item>
					<el-form-item label="失败原因">
						<span v-model="msg">
							{{this.msg?this.msg:"无"}}
						</span>
					</el-form-item>
					<el-form-item label="商品名称">
						<el-input v-model="form1.product.product_name"></el-input>
					</el-form-item>
					<el-form-item label="商品券ID">
						<el-input v-model="couponId" placeholder="请直接输入商品券ID"></el-input>
					</el-form-item>
					<el-form-item label="商品价格(输入100倍)">
						<el-input v-model="form1.sku.actual_amount"> </el-input>
					</el-form-item>
					<el-form-item label="商品原价(输入100倍)">
						<el-input v-model="form1.sku.origin_amount"> </el-input>
					</el-form-item>
					<el-form-item label="销售时间" placeholder="请设置销售时间">
						<el-date-picker v-model="sold_time" type="datetimerange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="详情文案">
						<quill-editor v-model="form2.description_rich_text[0].content" ref="myQuillEditor">
						</quill-editor>

						<!-- <el-input
							  type="textarea"
							  placeholder="请输入内容"
							  v-model="form2.description_rich_text[0].content"
							  maxlength="500"
							  show-word-limit
							  rows="10"
							></el-input> -->
					</el-form-item>
					<el-form-item label="详情图片">
						<el-upload class="upload-demo" action="https://admin.ciaojian.com/file/file_upload"
							:file-list="form2.environment_image_list" :on-success=environmentAdd
							:on-remove=environmentRemove list-type="picture">
							<el-button size="small" type="primary">点击上传</el-button>
						</el-upload>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" style="margin-left:50%;" @click="edit()">提交</el-button>
						<router-link to="/dyGoods"><el-button type="info"
								style="margin-left:10px;">返回</el-button></router-link>
					</el-form-item>
				</div>
			</el-form>
		</div>
	</div>
</template>

<script>
	import upload from "../compents/upload/upload";
	import {
		url,
		parseTime
	} from "../../utils/index.js";
	export default {
		components: {
			upload,
		},
		data() {
			return {
				url: url(),
				enter: false,
				showType: "",
				status: undefined,
				msg: "",
				addrs: [],
				stores: [],
				rosters: [],
				authoritys: [],
				typeShow: false,
				levels: [],
				couponId: undefined,
				f2: [],
				sendData: [],
				productIds: '',
				form1: {
					sku: {
						actual_amount: undefined,
						origin_amount: undefined
					},
					product: {
						product_name: undefined
					}
				},
				form2: {
					image_list: [],
					description_rich_text: '',
					environment_image_list: []
				},
				sold_time: [],
				image_list: [],
				image: [{
					url: "",
				}],
				environment_image_list: [],
				description_rich_text: []
			};
		},
		mounted() {
			this.productIds = this.$route.query.id;
			console.log(this.productIds)
			this.getStatus(this.productIds);
			this.getWorker();
		},
		created() {
			window.addEventListener("keydown", this.handleKeyDown)
		},
		filters: {
			statusFormat(val) {
				switch (val) {
					case 10:
						return "审核中";
					case 1:
						return "审核通过";
					case 12:
						return "审核拒绝";
					case 21:
						return "商家确认拒绝";
					case 22:
						return "商家确认通过";
					case 23:
						return "商家确认超时";
					case 20:
						return "商家确认中";
					case 11:
						return "审核通过";
					default:
						return '/';
				}
			}
		},
		methods: {
			butupload() {
				document.querySelector(".el-upload--picture-card").click();
			},
			add(fileList) {
				var a = fileList.data
				this.image_list.push(a)
				console.log(this.image_list)
			},
			remove(fileList) {
				var a = fileList.url
				var b = []
				b = this.image_list
				this.image_list = []
				for (var i = 0; i < b.length; i++) {
					if (b[i] != a) {
						this.image_list.push(b[i])
					}
				}
				console.log(this.image_list)
			},
			environmentAdd(fileList) {
				var a = fileList.data
				this.environment_image_list.push(a)
				console.log(this.environment_image_list)
			},
			environmentRemove(fileList) {
				var a = fileList.url
				var b = []
				b = this.environment_image_list
				this.environment_image_list = []
				for (var i = 0; i < b.length; i++) {
					if (b[i] != a) {
						this.environment_image_list.push(b[i])
					}
				}
				console.log(this.environment_image_list)
			},
			edit() {
				var a = {}
				a.productId = this.productIds
				a.couponId = this.couponId
				a.actualAmount = this.form1.sku.actual_amount
				a.originAmount = this.form1.sku.origin_amount
				a.productName = this.form1.product.product_name
				a.imageList = this.image_list
				var b = this.form2.description_rich_text[0].content
				a.text = b.replace(/"/g, '\\\"');
				console.log(this.form2.description_rich_text[0].content)
				console.log(b)
				console.log(a.text)
				a.envImageList = this.environment_image_list
				a.startDate = this.sold_time[0].valueOf() / 1000
				a.endDate = this.sold_time[1].valueOf() / 1000
				console.log(a)
				this.$http.post("https://cj.ciaojian.com//bytedance/goods/update", JSON.stringify(a)).then(res => {
					console.log(res)
					this.$router.push({
						path: '/dyGoods'
					});
				})
			},
			getStatus() {
				this.$http.get("https://cj.ciaojian.com//bytedance/goods/draft/get/?productIds=" + this.productIds).then(
					res => {
						if (res.body.code == 200) {
							this.status = res.body.data.data.product_draft_list[0].draft_status
							this.msg = res.body.data.data.product_draft_list[0].audit_msg
						}
					})
			},
			// http://192.168.0.5:9090/bytedance/goods/draft/get/?productIds=7185082836116949003
			getWorker() {
				this.$http.get("https://cj.ciaojian.com//bytedance/goods/product/get/?productIds=" + this.productIds +
					"&outIds=" + this.productIds).then(res => {
					if (res.body.code == 200) {
						this.form1 = res.body.data.product_online_list[0];
						this.form2 = res.body.data.product_online_list[0].product.attr_key_value_map;
						var a = new Date(this.form1.product.sold_start_time * 1000)
						var b = new Date(this.form1.product.sold_end_time * 1000)
						this.sold_time = [a, b]

						for (var i = 0; i < this.form2.image_list.length; i++) {
							this.image_list.push(this.form2.image_list[i].url)
						}
						for (var j = 0; j < this.form2.environment_image_list.length; j++) {
							this.environment_image_list.push(this.form2.environment_image_list[j].url)
						}
					}
				})
			}
		},
	}
</script>

<style>
	.el-tabs-pane-nav {
		position: relative;
		padding-left: 15px;
	}

	.el-tabs-pane-nav::before {
		content: " ";
		height: 20px;
		width: 6px;
		display: block;
		position: absolute;
		top: 3px;
		left: 0;
		background: #449bfb;
		border-radius: 2px;
	}

	.el-upload-list__item {
		height: 220px;
		width: 230px;
		display: flex;
		float: left;

	}

	.el-upload-list--picture .el-upload-list__item-thumbnail {
		width: 200px;
		height: 200px;

	}

	.el-upload-list--picture .el-upload-list__item {
		overflow: hidden;
		z-index: 0;
		background-color: #fff;
		border: 1px solid #c0ccda;
		border-radius: 6px;
		box-sizing: border-box;
		margin-top: 10px;
		padding: 10px 10px 10px 90px;
		height: 220px;
	}


	.el-tabs-pane-upload2 {
		width: 200px;
		height: 200px;
		display: flex;
		float: left;
	}

	.el-tabs-pane-user {
		display: flex;
	}

	.el-input__inner {
		height: 32px;
	}

	.el-form-item {
		margin-bottom: 10px;
	}

	.el-tabs-pane-upload-item2 {
		margin-left: 10px;
		width: 70%;
	}

	.bottom-item {
		margin-left: 5px;
		padding: 8px 15px;
	}

	.hairInfo .el-dialog {
		border-radius: 20px;
	}

	.hairInfo .el-dialog__title {
		display: block;
		position: relative;
		padding-left: 12px;
	}

	.hairInfo .el-dialog__title::before {
		content: " ";
		height: 20px;
		width: 6px;
		display: block;
		position: absolute;
		top: 3px;
		left: 0;
		background: #449bfb;
		border-radius: 2px;
	}
</style>